import * as React from 'react';

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M5 15.3406V8.6594C5 8.25937 5.2384 7.89783 5.60608 7.74025L11.6061 5.16882C11.8576 5.06102 12.1424 5.06102 12.3939 5.16882L18.3939 7.74025C18.7616 7.89783 19 8.25937 19 8.6594V15.3406C19 15.7406 18.7616 16.1022 18.3939 16.2597L12.3939 18.8312C12.1424 18.939 11.8576 18.939 11.6061 18.8312L5.60608 16.2597C5.2384 16.1022 5 15.7406 5 15.3406Z"
      stroke={props.color || '#FFF'}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M12 11V19M12 11L5 8M12 11L19 8" stroke={props.color || '#FFF'} strokeWidth="2" />
  </svg>
);
